export function isC3Experience() {
    return window.location.hash.split('/').length > 1 && window.location.hash.split('/')[1].startsWith('C3_');
}


// WEBPACK FOOTER //
// ./src/shared/util/C3Utils.js